import { Injectable } from '@angular/core';
import { SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';

@Injectable({
  providedIn: 'root'
})
export class CssLoaderService extends SafariInjector {
  load(styleName: string) {
    const head = this.document.getElementsByTagName('head')[0];
    const id = 'safari-style-' + styleName;
    const themeLink = this.document.getElementById(id) as HTMLLinkElement;
    if (!themeLink) {
      const style = this.document.createElement('link');
      style.id = id;
      style.type = 'text/css';
      style.rel = 'stylesheet';
      style.href = styleName + '.css';

      head.appendChild(style);
    }
  }
  unload(styleName: string) {
    const id = 'safari-style-' + styleName;
    const themeLink = this.document.getElementById(id) as HTMLLinkElement;
    if (themeLink) {
      themeLink.parentNode.removeChild(themeLink);
    }
  }
}
